// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    InputControl,
} from "../../../molecules";
import {
    Box,
    FormControl,
    Stack,
    Typography,
    useTheme,
    useMediaQuery,
    Switch,
    FormControlLabel,
    Divider,
    Card,
    CardHeader,
    CardContent
} from "@mui/material";
import { Controller } from "react-hook-form";
import {
    IMerchant,
} from "../../../../hooks";
import { useEffect, useState } from "react";

export interface MerchantAddFormAuthorizationSectionFormStates {
    isRestrictedLink: boolean;
    isLinkCreationActive: boolean;
    isNonSecureActive: boolean;
    linkExpireInMinutes: number;
    linkQuantity: number;
    isUnlimitedLinkActive: boolean;
    hasManualInstallmentManagement: boolean;
    setHasManualInstallmentManagement: any;
}

export const MerchantAddFormAuthorizationSection = ({ merchant, control, formState, setFormState, hasManualInstallmentManagement, setHasManualInstallmentManagement }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

    const [isFirstLoadFinshed, setIsFirstLoadFinshed] = useState(false);

    useEffect(() => {
        if (!isFirstLoadFinshed && merchant) {
            setFormState({
                isNonSecureActive: merchant.nonSecure || false,
                isLinkCreationActive: merchant.linkPaymentActive || false,
                isRestrictedLink: merchant.restrictedLink || false,
                isUnlimitedLinkActive: merchant.isUnlimitedLink || false,
                linkExpireInMinutes: merchant.linkExpireInMinutes || 0,
                linkQuantity: merchant.linkQuantity || 0,
            });
            if (setHasManualInstallmentManagement) {
                setHasManualInstallmentManagement(merchant.hasManualInstallmentManagement || false);
            }
            setIsFirstLoadFinshed(true);
        }
    }, [merchant, isFirstLoadFinshed, setFormState, setHasManualInstallmentManagement]);

    const handleChange = <K extends keyof MerchantAddFormAuthorizationSectionFormStates>(
        key: K,
        value: MerchantAddFormAuthorizationSectionFormStates[K]
    ) => {
        setFormState((prevState) => ({
            ...prevState,
            [key]: value
        }));
    };

    if (!isFirstLoadFinshed) {
        return null; // Or a loading indicator
    }

    return (
        <Box p={isDesktop ? 2 : 1}>
            <Card variant="outlined">
                <CardHeader title="Yetkilendirme Ayarları" subheader="İşlem ve link oluşturma yetkilerini yönetin" />
                <CardContent>
                    <Stack spacing={4} divider={<Divider />}>
                        {/* General Authorizations Section */}
                        <Stack spacing={2}>
                            <Typography variant="h6" gutterBottom>Genel Yetkiler</Typography>
                            <Box>
                                <FormControlLabel
                                    control={<Switch checked={formState.isNonSecureActive} onChange={(e) => handleChange('isNonSecureActive', e.target.checked)} />}
                                    label="Non-Secure (3D'siz) İşlem"
                                />
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 4 }}>
                                    3D Secure doğrulaması olmadan ödeme alınmasını etkinleştirir.
                                </Typography>
                            </Box>
                            <Box>
                                <FormControlLabel
                                    control={<Switch checked={hasManualInstallmentManagement} onChange={(e) => setHasManualInstallmentManagement(e.target.checked)} />}
                                    label="Manuel Taksit Yönetimi"
                                />
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 4 }}>
                                    Varsayılan taksit ayarları yerine manuel taksit girişine izin verir.
                                </Typography>
                            </Box>
                        </Stack>

                        {/* Link Settings Section */}
                        <Stack spacing={2}>
                            <Typography variant="h6" gutterBottom>Link ile Ödeme Yetkileri</Typography>
                            <Box>
                                <FormControlLabel
                                    control={<Switch checked={formState.isLinkCreationActive} onChange={(e) => handleChange('isLinkCreationActive', e.target.checked)} />}
                                    label="Link ile Ödeme"
                                />
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 4 }}>
                                    Müşterilere ödeme linki göndererek ödeme alınmasını sağlar.
                                </Typography>
                            </Box>

                            {/* Container for dependent link settings */}
                            <Box
                                sx={{
                                    pl: 2,
                                    ml: 2,
                                    borderLeft: 1,
                                    borderColor: 'divider',
                                    transition: 'opacity 0.3s',
                                    opacity: formState.isLinkCreationActive ? 1 : 0.5,
                                    pointerEvents: formState.isLinkCreationActive ? 'auto' : 'none'
                                }}
                            >
                                <Stack spacing={2} pt={2}>
                                    {/* Restricted Link Subsection */}
                                    <Box>
                                        <FormControlLabel
                                            control={<Switch checked={formState.isRestrictedLink} onChange={(e) => handleChange('isRestrictedLink', e.target.checked)} />}
                                            label="Kısıtlı Link"
                                        />
                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 4 }}>
                                            Tek kullanımlık ve süreli linkler oluşturur.
                                        </Typography>
                                    </Box>
                                    <Stack spacing={2} direction="row" sx={{
                                        pl: 4,
                                        transition: 'opacity 0.3s',
                                        opacity: formState.isRestrictedLink ? 1 : 0.5,
                                        pointerEvents: formState.isRestrictedLink ? 'auto' : 'none'
                                    }}>
                                        <FormControl fullWidth>
                                            <InputControl
                                                id="linkExpireInMinutes"
                                                name="linkExpireInMinutes"
                                                control={control}
                                                label="Geçerlilik (Dakika)"
                                                numeric
                                            />
                                        </FormControl>
                                        <FormControl fullWidth>
                                            <InputControl
                                                id="linkQuantity"
                                                control={control}
                                                numeric
                                                label="Günlük Limit"
                                            />
                                        </FormControl>
                                    </Stack>

                                    {/* Unlimited Link Subsection */}
                                    <Box>
                                        <FormControlLabel
                                            control={<Switch checked={formState.isUnlimitedLinkActive} onChange={(e) => handleChange('isUnlimitedLinkActive', e.target.checked)} />}
                                            label="Sınırsız Kullanımlı Link"
                                        />
                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 4 }}>
                                            Süresiz ve kullanım limiti olmayan kalıcı linkler oluşturur.
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Box>
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
}